import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Card } from "../components/ui/card";

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit-logs").then((r) => setRows(r.data)); }, []);
  return (
    <div className="space-y-6" data-testid="audit-page">
      <div>
        <h1 className="heading text-2xl font-extrabold tracking-tight">Audit Log</h1>
        <p className="text-sm text-muted-foreground">Chronological log of all financial changes.</p>
      </div>
      <Card className="p-0 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50"><tr className="text-left text-xs uppercase text-muted-foreground"><th className="p-3">When</th><th className="p-3">User</th><th className="p-3">Action</th><th className="p-3">Entity</th><th className="p-3">Reference</th></tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t table-row-hover">
                <td className="p-3 mono text-xs">{new Date(r.created_at).toLocaleString()}</td>
                <td className="p-3">{r.user_email || "—"}</td>
                <td className="p-3 font-medium">{r.action}</td>
                <td className="p-3 text-muted-foreground">{r.entity_type}</td>
                <td className="p-3 mono text-xs text-muted-foreground">{r.entity_id?.slice(0, 8)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-muted-foreground">No audit entries yet.</td></tr>}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
